module.exports = __webpack_public_path__ + "img/Wp_2056.da2a56f1.png";